var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UsersList',{attrs:{"users":_vm.users,"search":_vm.search,"headers":_vm.headers}})}
var staticRenderFns = []

export { render, staticRenderFns }